module.exports = __webpack_public_path__ + "img/icomoon.9bf854ae.svg";